import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import footLogo from "../../Assets/images/dignity_logo_footer.png"
import { useTranslation } from "react-i18next";


const Footer = () => {
  const currentYear = new Date().getFullYear();
  const {t} = useTranslation();

  return (
    <>
      <div id="footer">
        <div className="footer_top">
          <Container>
            <Row>
              <Col sm={6} md={3} lg={3} >
                <div className="foot_info">
                  <div className="logo">
                    <img src={footLogo} alt="" />
                  </div>
                  <div className="foot_cont">
                    <h6>{t("Custom ChatBot for your data")}</h6>
                    <p>
                      {t("Just connect your data sources and get a AI powered chatbot for your data. Then add it as a widget to your website or simply utilize a public URL.")}
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="footer_bot">
          <Container>
            <Row>
              <Col md={12}>
                <span className="copyright">
                  © {currentYear} Support assistant. all rights reserved
                </span>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default Footer;